import { useEffect } from "react";

import BottomDrawer from "components/BottomDrawer";
import ClientTranslation from "components/ClientTranslation";
import Flex from "components/Flex";
import { NoInternetIcon } from "components/Icons/NoInternet";
import Loader from "components/Loader";
import PageLayout from "components/PageLayout";
import Text from "components/Text";

import { useClientTranslation } from "hooks/useClientTranslation";
import { useEventTracking } from "hooks/useEventTracking";

import { usePollEstimate } from "./hooks/usePollEstimate";

export const EstimateAnalysis = () => {
  const { t } = useClientTranslation();

  const { trackEvent } = useEventTracking();

  usePollEstimate();

  useEffect(() => {
    if (!navigator.onLine) {
      trackEvent({ name: "Offline" });
    }
  }, [trackEvent]);

  return (
    <PageLayout title={t("estimate_loading.header")} dataTestId="estimateAnalysis">
      <Flex py={16} px={24} gap={16} style={{ height: "100%" }}>
        <Text sizeVariant="md">{t("estimate_loading.instruction")}</Text>
        <Text sizeVariant="md">
          <ClientTranslation i18nKey="estimate_loading.stay">{t("estimate_loading.stay")}</ClientTranslation>
        </Text>
        <Loader message={t("estimate_loading.checking")} />
      </Flex>

      <BottomDrawer
        isOpen={!navigator.onLine}
        closeOnClickOutside={false}
        heading={t("offline.header")}
        headingIcon={<NoInternetIcon />}
      >
        <Text sizeVariant="md">{t("offline.instruction")}</Text>
      </BottomDrawer>
    </PageLayout>
  );
};
